import {Component} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {CrudEdit} from '../../../../shared/components/crud-edit';
import {CrudToolsService} from '../../../../shared/services/crud-tools.service';
import {AbstractCrudEditComponent} from '@shared/library/crud-library/abstract-crud-edit.component';
import {ApiFactoryService} from '@shared/services/api-factory.service';
import {AlertService} from '@shared/services/alert.service';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {CrudFlagsService} from "@shared/services/crud-flags.service";

@Component({
  selector: 'app-tools-edit',
  templateUrl: './tools-edit.component.html',
  styleUrls: ['./tools-edit.component.scss']
})
export class ToolsEditComponent extends AbstractCrudEditComponent {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    private httpcrud: CrudToolsService,
    protected toolService: CrudToolsService,
    protected apifactory: ApiFactoryService,
    protected alertService: AlertService,
    private flagservice: CrudFlagsService,
  ) {
    super(activatedRoute, router, apifactory, httpcrud, alertService);

    this.fields = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            className: 'col-12',
            fieldGroup: [
              {
                fieldGroupClassName: 'row',
                fieldGroup: [
                  {
                    className: 'col-4',
                    fieldGroup: [
                      {
                        key: 'label_en',
                        type: 'input',
                        templateOptions: { label: 'Label (english)', required: true }
                      }
                    ]
                  },
                  {
                    className: 'col-4',
                    fieldGroup: [
                      {
                        key: 'label_fr',
                        type: 'input',
                        templateOptions: { label: 'Label (french)', required: true }
                      }
                    ]
                  },
                  {
                    className: 'col-4',
                    fieldGroup: [
                      {
                        key: 'label_de',
                        type: 'input',
                        templateOptions: { label: 'Label (german)', required: true }
                      }
                    ]
                  },
                ]
              },
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                fieldGroupClassName: 'row',
                fieldGroup: [
                  {
                    className: 'col-4',
                    fieldGroup: [
                      {
                        key: 'flagcategorytoolgroup',
                        type: 'ng-select2',
                        defaultValue: 0,
                        props: {
                          label: 'toolgroup',
                          required: true,
                          bindLabel: 'flagkey',
                          clearable: true
                        },
                        hooks: {
                          onInit: this.initToolgroupFlagcategory
                        }
                      }
                    ]
                  },
                  {
                    className: 'col-4',
                    fieldGroup: [
                      {
                        key: 'flagcategorymandant',
                        type: 'ng-select2',
                        defaultValue: 0,
                        props: {
                          label: 'mandant',
                          required: true,
                          bindLabel: 'flagkey',
                          clearable: true
                        },
                        hooks: {
                          onInit: this.initMandantFlagcategory
                        }
                      }
                    ]
                  },
                  {
                    className: 'col-4',
                    fieldGroup: [
                      {
                        key: 'flagcategoryenvname',
                        type: 'ng-select2',
                        defaultValue: 0,
                        props: {
                          label: 'envname',
                          required: true,
                          bindLabel: 'flagkey',
                          clearable: true
                        },
                        hooks: {
                          onInit: this.initEnvnameFlagcategory
                        }
                      }
                    ]
                  },
                ]
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'keyword',
                type: 'input',
                templateOptions: { label: 'Keyword', required: true }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'client',
                type: 'ng-select',
                defaultValue: 0,
                props: {
                  label: 'Client',
                  required: true,
                  closeOnSelect: true
                },
                hooks: {
                  onInit: this.initAppClient
                }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'envName',
                type: 'ng-select',
                defaultValue: 0,
                templateOptions: {
                  label: 'Environment',
                  required: true,
                  closeOnSelect: true,
                  options: [
                    {label: 'Production', id: 'prod'},
                    {label: 'Beta', id: 'beta'},
                    {label: 'Alpha', id: 'alpha'},
                    {label: 'Development', id: 'dev'}
                  ]
                }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'basetoolurl',
                type: 'input',
                templateOptions: { label: 'Tool URL', required: true }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'classname',
                type: 'ng-select',
                defaultValue: 0,
                templateOptions: {
                  label: 'Class name',
                  required: true,
                  closeOnSelect: true,
                  options: [
                    {id: 'imagebank', label: 'imagebank'},
                    {id: 'dos', label: 'dos'},
                    {id: 'cavok', label: 'cavok'},
                    {id: 'aos', label: 'aos'},
                    {id: 'instore', label: 'instore'},
                    {id: 'tokensuffix', label: 'tokensuffix'},
                    {id: 'tokensuffixdecodedlanguagemandantlabel', label: 'tokensuffixdecodedlanguagemandantlabel'}
                  ]
                }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'sort',
                type: 'input',
                templateOptions: { label: 'Sort index', required: true }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'externalid',
                type: 'input',
                templateOptions: { label: 'External ID' }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'active',
                type: 'checkbox',
                defaultValue: true,
                templateOptions: {label: 'Active'}
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'sync',
                type: 'checkbox',
                defaultValue: false,
                templateOptions: {label: 'Synchronize'}
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'activeorderlisttab',
                type: 'checkbox',
                defaultValue: false,
                templateOptions: {label: 'Activate order list tab'}
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'orderlistapi',
                type: 'input',
                templateOptions: { label: 'Order list api (with params ?languagekey=en&...)' }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'orderlistdetailapi',
                type: 'input',
                templateOptions: { label: 'Order list detail api root ([https://bc-dev.media4.ch/api/v1/orders]/142?languagekey=en&... )' }
              }
            ]
          },
          {
            className: 'col-12',
            fieldGroup: [
              {
                key: 'syncapiroot',
                type: 'input',
                templateOptions: { label: 'Sync api root (example: https://api-calitho.localdev.ch/api2/aos2/v1/protected)' }
              }
            ]
          }
        ]
      }
    ];

    this.createSectionTitle = 'Create tool';
    this.updatePrefixTitle = 'Edit tool: ';
    this.labelFieldName = 'label_en';

    this.entityrooturl = '/admin/tools';
  }

  initAppClient = (field: any) => {
    const typedField: Required<FormlyFieldConfig> = field;
    const query = this.bffapi.getClients();
    query.subscribe((data) => {
      const clients = data.results;
      typedField.templateOptions.options = clients;
      // typedField.templateOptions.options = [{label: 'Global', id: 0}, ...clients];

      // Mandatory for ng-select
      this.form.get('client')?.setValue(this.model.client);

    });
  }

  initEnvnameFlagcategory = (field: any) => {
    const typedField: Required<FormlyFieldConfig> = field;
    this.flagservice.getFlagsByEnvnameFlagcategorykey().subscribe((data) => {
      typedField.props.options = data.results;

      // For ng-select2, mandatory to set even already get from this.model
      this.form.get('flagcategoryenvname')?.setValue(this.model.flagcategoryenvname);
    });
  }

  initToolgroupFlagcategory = (field: any) => {
    const typedField: Required<FormlyFieldConfig> = field;
    this.flagservice.getFlagsByToolgroupFlagcategorykey().subscribe((data) => {
      typedField.props.options = data.results;

      // For ng-select2, mandatory to set even already get from this.model
      this.form.get('flagcategorytoolgroup')?.setValue(this.model.flagcategorytoolgroup);

    });
  }

  initMandantFlagcategory = (field: any) => {
    const typedField: Required<FormlyFieldConfig> = field;
    this.flagservice.getFlagsByMandantFlagcategorykey().subscribe((data) => {
      typedField.props.options = data.results;

      // For ng-select2, mandatory to set even already get from this.model
      this.form.get('flagcategorymandant')?.setValue(this.model.flagcategorymandant);
    });
  }

}
